<template>
	<AppLayout :title="certificate.title" :return-url="returnUrl" :return-label="returnLabel">
		<Modal id="show-variables-modal" no-footer>
			<template #title>{{ trans('certificate.variables.title') }}</template>
			<LabeledObject class="cursor-pointer">
				<template #label>{{ trans('certificate.variables.first_name') }}</template>
				<PrimaryButton :color="Color.Blue" class="place-self-start" @click.stop="copyCode('{first_name}')">{{ trans('general.copy') }} {first_name}</PrimaryButton>
			</LabeledObject>
			<LabeledObject class="cursor-pointer">
				<template #label>{{ trans('certificate.variables.middle_name') }}</template>
				<PrimaryButton :color="Color.Blue" class="place-self-start" @click.stop="copyCode('{middle_name}')">{{ trans('general.copy') }} {middle_name}</PrimaryButton>
			</LabeledObject>
			<LabeledObject class="cursor-pointer">
				<template #label>{{ trans('certificate.variables.last_name') }}</template>
				<PrimaryButton :color="Color.Blue" class="place-self-start" @click.stop="copyCode('{last_name}')">{{ trans('general.copy') }} {last_name}</PrimaryButton>
			</LabeledObject>
			<LabeledObject class="cursor-pointer">
				<template #label>{{ trans('certificate.variables.full_name') }}</template>
				<PrimaryButton :color="Color.Blue" class="place-self-start" @click.stop="copyCode('{full_name}')">{{ trans('general.copy') }} {full_name}</PrimaryButton>
			</LabeledObject>
			<LabeledObject class="cursor-pointer">
				<template #label>{{ trans('certificate.variables.id_number') }}</template>
				<PrimaryButton :color="Color.Blue" class="place-self-start" @click.stop="copyCode('{id_number}')">{{ trans('general.copy') }} {id_number}</PrimaryButton>
			</LabeledObject>
			<LabeledObject class="cursor-pointer">
				<template #label>{{ trans('certificate.variables.email') }}</template>
				<PrimaryButton :color="Color.Blue" class="place-self-start" @click.stop="copyCode('{email}')">{{ trans('general.copy') }} {email}</PrimaryButton>
			</LabeledObject>
			<LabeledObject class="cursor-pointer">
				<template #label>{{ trans('certificate.variables.college') }}</template>
				<PrimaryButton :color="Color.Blue" class="place-self-start" @click.stop="copyCode('{college}')">{{ trans('general.copy') }} {college}</PrimaryButton>
			</LabeledObject>
			<LabeledObject class="cursor-pointer">
				<template #label>{{ trans('certificate.variables.role') }}</template>
				<PrimaryButton :color="Color.Blue" class="place-self-start" @click.stop="copyCode('{role}')">{{ trans('general.copy') }} {role}</PrimaryButton>
			</LabeledObject>
		</Modal>
		<template #actions>
			<PrimaryButton :color="Color.Gray" @click.stop="showModal('show-variables-modal')">
				<i class="fa-regular fa-circle-question"/>
			</PrimaryButton>
			<PrimaryButton :color="Color.Indigo" @click.stop="addText">
				<i class="fa-solid fa-font"/>
			</PrimaryButton>
			<PrimaryButton :color="Color.Indigo" @click.stop="addImage">
				<i class="fa-solid fa-image"/>
			</PrimaryButton>
			<PrimaryButton :color="Color.Indigo" @click.stop="addQR">
				<i class="fa-solid fa-qrcode"/>
			</PrimaryButton>
			<PrimaryButton :color="Color.Green" @click.stop="update">
				<i class="fa-solid fa-check mr-2"/>
				{{ trans('general.save') }}
			</PrimaryButton>
		</template>
		<Properties v-if="selectedModule" :key="`module-properties-${selectedModule.id}`" v-model="selectedModule" :max-width="maxWidth" :max-height="maxHeight" @delete-module="deleteModule"/>
		<div v-else class="px-3 py-2 flex items-end gap-3">
			<LabeledObject required>
				<template #label>{{ trans('certificate.info.title') }}</template>
				<input v-model="certificate.title" type="text">
			</LabeledObject>
			<LabeledObject required>
				<template #label>{{ trans('certificate.info.author') }}</template>
				<input v-model="certificate.author" type="text">
			</LabeledObject>
			<LabeledObject required>
				<template #label>{{ trans('certificate.info.creator') }}</template>
				<input v-model="certificate.creator" type="text">
			</LabeledObject>
			<LabeledObject>
				<template #label>{{ trans('certificate.info.orientation') }}</template>
				<select v-model="certificate.orientation">
					<option v-for="orientation in CertificateOrientation" :value="orientation">{{ trans(`certificate.info.orientations.${orientation}`) }}</option>
				</select>
			</LabeledObject>
			<LabeledObject>
				<template #label>{{ trans('certificate.info.size') }}</template>
				<select v-model="certificate.size">
					<option v-for="size in CertificateSize" :value="size">{{ trans(`certificate.info.sizes.${size}`) }}</option>
				</select>
			</LabeledObject>
		</div>
		<div class="grow flex flex-col overflow-y-auto" @click="onClickOut">
			<div class="grow flex items-stretch divide-x divide-gray-200 dark:divide-gray-900 overflow-y-auto">
				<div class="grow p-4 flex items-start justify-center relative overflow-auto bg-gray-100 dark:bg-gray-700">
					<div :class="`relative bg-white border border-gray-200 w-[960px] ${aspect}`">
						<div class="h-full w-[1px] bg-gray-200 absolute left-[1cm] z-20"/>
						<div class="h-full w-[1px] bg-gray-200 absolute left-1/2 z-20"/>
						<div class="h-full w-[1px] bg-gray-200 absolute right-[1cm] z-20"/>
						<div class="w-full h-[1px] bg-gray-200 absolute top-[1cm] z-20"/>
						<div class="w-full h-[1px] bg-gray-200 absolute top-1/2 z-20"/>
						<div class="w-full h-[1px] bg-gray-200 absolute bottom-[1cm] z-20"/>
						<CertificateModule v-for="(certificateModule, key) in certificate.modules" :key="`item-module-${certificateModule.id}`" v-model:editing-text="editingText" :model-value="certificateModule" :max-width="maxWidth" :max-height="maxHeight" :selected="selectedModule?.id === certificateModule.id" @update:model-value="updateModule" @select="selectModule(key)" @delete="deleteModule" @click.stop=""/>
					</div>
				</div>
				<!--<div class="flex flex-col divide-y dark:divide-gray-800 bg-gray-100 dark:bg-gray-800 overflow-y-auto">
					<div class="px-3 py-2">Layers</div>
				</div>-->
			</div>
		</div>
	</AppLayout>
</template>
<script setup lang="ts">
import _ from 'lodash'
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import AppLayout from '@/Layouts/AppLayout.vue'
import Modal from '@/Components/UI/Modals/Modal.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import {CertificateSize} from '@/Types/Enums/CertificateSize'
import {type Certificate} from '@/Types/Certificates/Certificate'
import Properties from '@/Components/Certificates/Properties.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {computed, type ComputedRef, defineProps, ref, type Ref} from 'vue'
import {CertificateOrientation} from '@/Types/Enums/CertificateOrientation'
import CertificateModule from '@/Components/Certificates/CertificateModule.vue'
import {type CertificateQrModule} from '@/Types/Certificates/CertificateQrModule'
import {type CertificateCellModule} from '@/Types/Certificates/CertificateCellModule'
import {type CertificateImageModule} from '@/Types/Certificates/CertificateImageModule'
import {type CertificateModule as Module} from '@/Types/Certificates/CertificateModule'
import {copyTextToClipboard, showInfo, showModal, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	returnUrl:string,
	returnLabel:string,
	certificate:Certificate,
}>()

const certificate:Ref<Certificate> = ref(props.certificate)
const selectedItemKey:Ref<number|null> = ref(null)
const selectedModule:Ref<Module|null> = ref(null)
const editingText:Ref<boolean> = ref(false)
const working:Ref<boolean> = ref(false)
const module:Ref<Module> = ref({
	id: 0,
	x: 0,
	y: 0,
	w: 200,
	h: 200,
	qr: null,
	cell: null,
	image: null,
	lock_ratio: false,
})
const cellModule:Ref<CertificateCellModule> = ref({
	font: 'helvetica',
	font_size: 12,
	txt: '',
	border: 0,
	ln: 0,
	align: 'L',
	bold: false,
	italic: false,
	underlined: false,
	fill: false,
	color: '#000000',
})
const qrModule:Ref<CertificateQrModule> = ref({
	code: true,
	font: 'helvetica',
	font_size: 12,
	border: 0,
	ln: 0,
	align: 'L',
	bold: false,
	italic: false,
	underlined: false,
	fill: false,
	color: '#000000',
})
const imageModule:Ref<CertificateImageModule> = ref({
	file: 'no_img.png',
})

const aspect:ComputedRef<string> = computed(() => {
	if(certificate.value){
		if([CertificateSize.A3, CertificateSize.A4, CertificateSize.A5].includes(certificate.value.size)){
			return certificate.value.orientation === CertificateOrientation.Portrait ? 'aspect-[1/1.4142]' : 'aspect-[1.4142/1]'
		}
		if(certificate.value.size === CertificateSize.Letter){
			return certificate.value.orientation === CertificateOrientation.Portrait ? 'aspect-[1/1.2941]' : 'aspect-[1.2941/1]'
		}
		if(certificate.value.size === CertificateSize.Legal){
			return certificate.value.orientation === CertificateOrientation.Portrait ? 'aspect-[1/1.6471]' : 'aspect-[1.6471/1]'
		}
	}
	return ''
})
const maxWidth:ComputedRef<number> = computed(() => {
	if([CertificateSize.A3, CertificateSize.A4, CertificateSize.A5].includes(certificate.value.size)){
		return certificate.value.orientation === CertificateOrientation.Landscape ? 960 : 680
	}
	if(certificate.value.size === CertificateSize.Legal){
		return certificate.value.orientation === CertificateOrientation.Landscape ? 960 : 680
	}
	if(certificate.value.size === CertificateSize.Letter){
		return certificate.value.orientation === CertificateOrientation.Landscape ? 960 : 680
	}
	return certificate.value.orientation === CertificateOrientation.Landscape ? 960 : 680
})
const maxHeight:ComputedRef<number> = computed(() => {
	if([CertificateSize.A3, CertificateSize.A4, CertificateSize.A5].includes(certificate.value.size)){
		return certificate.value.orientation === CertificateOrientation.Landscape ? 680 : 960
	}
	if(certificate.value.size === CertificateSize.Legal){
		return certificate.value.orientation === CertificateOrientation.Landscape ? 680 : 960
	}
	if(certificate.value.size === CertificateSize.Letter){
		return certificate.value.orientation === CertificateOrientation.Landscape ? 680 : 960
	}
	return certificate.value.orientation === CertificateOrientation.Landscape ? 680 : 960
})

async function copyCode(code:string):Promise<void>{
	copyTextToClipboard(code).then(() => {
		showSuccess(trans('general.copied_to_clipboard'))
	})
}

function onClickOut():void{
	deselectModule()
	stopEditingText()
}

function stopEditingText():void{
	editingText.value = false
}

function update():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('certificates.update', certificate.value.id), certificate.value).then(() => {
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}

function addModule(module:Module):void{
	module.id = certificate.value.next_module_id;
	const newLength:number = certificate.value.modules.push(module)
	certificate.value.next_module_id++;
	selectModule(newLength - 1)
}

function deleteModule():void{
	if(selectedItemKey.value !== null){
		const key = selectedItemKey.value
		deselectModule()
		certificate.value.modules.splice(key, 1)
	}
}

function addText():void{
	let newModule = _.clone(module.value)
	newModule.w = 960
	newModule.h = 40
	newModule.cell = _.clone(cellModule.value)
	addModule(newModule)
}

function addImage():void{
	let newModule = _.clone(module.value)
	newModule.w = 960
	newModule.h = 680
	newModule.image = _.clone(imageModule.value)
	addModule(newModule)
}

function addQR():void{
	let newModule = _.clone(module.value)
	newModule.w = 100
	newModule.h = 100
	newModule.qr = _.clone(qrModule.value)
	addModule(newModule)
}

function selectModule(key:number):void{
	deselectModule()
	selectedModule.value = certificate.value.modules[key]
	selectedItemKey.value = key
}

function deselectModule():void{
	selectedModule.value = null
	selectedItemKey.value = null
}

function updateModule(updatedModule:Module){
	if(selectedModule.value){
		selectedModule.value = updatedModule
	}
}
</script>
